import { type Command } from '@telespot/core';

export interface ListUserMembershipsPayload {
  userId: string;
  organizationId: string;
}

export const LIST_USER_MEMBERSHIPS = 'workspaces:listUserMemberships';

export class ListUserMemberships implements Command<typeof LIST_USER_MEMBERSHIPS, ListUserMembershipsPayload> {
  public readonly name = LIST_USER_MEMBERSHIPS;
  constructor(public readonly details: Readonly<ListUserMembershipsPayload>) {}
}
